import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { EnvironmentService } from '../../../environment.service';
import { SharedsService } from '../../../shareds/shareds.service';
import { ExceptionHandlerService } from '../../../exception-handler.service';

@Injectable({
  providedIn: 'root',
})
export class RagService {
  apiUrl: string;
  httpOptions: any;
  argument: any;
  user: any;
  constructor(
    private readonly http: HttpClient,
    private readonly envService: EnvironmentService,
    private readonly sharedService: SharedsService,
    private readonly expService: ExceptionHandlerService,
  ) {
    this.apiUrl = this.envService.read('apiUrl');
    this.user = JSON.parse(localStorage.getItem('user'))
      ? JSON.parse(localStorage.getItem('user'))
      : '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.envService.read('Authorization'),
        'access-token': this.sharedService.token,
      }),
    };
  }

  listRags(args): Observable<any> {
    if (!args.search) {
      this.httpOptions.params = new HttpParams()
        .set('timeZone', this.sharedService.timeZone)
        .set('type', args.type)
        .set('limit', args.limit)
        .set('skip', args.skip)
        .set('language', args.language)
        .set('appId', this.sharedService.appId);
    } else {
      console.log('124');
      this.httpOptions.params = new HttpParams()
        .set('timeZone', this.sharedService.timeZone)
        .set('type', args.type)
        .set('limit', args.limit)
        .set('skip', args.skip)
        .set('search', args.search)
        .set('language', args.language)
        .set('appId', this.sharedService.appId);
    }
    return this.http
      .get<any>(`${this.apiUrl}/list/ragDocument`, this.httpOptions)
      .pipe(
        tap(),
        catchError((error) => {
          this.expService.handleError(error);
          return of(error);
        }),
      );
  }
  languageSelector(): Observable<any> {
    this.httpOptions.params = null;
    return this.http
      .post<any>(
        `${this.apiUrl}/dashboard/questions/language_selector`,
        this.argument,
        this.httpOptions,
      )
      .pipe(
        tap(),
        catchError((error) => {
          this.expService.handleError(error);
          return of(error);
        }),
      );
  }
}
